import { render, staticRenderFns } from "./bind-mobile.vue?vue&type=template&id=b51fe560"
import script from "./bind-mobile.vue?vue&type=script&lang=js"
export * from "./bind-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports